import React, { useState } from 'react';
import {
  Col,
  Form,
  Row,
  Typography,
  Upload,
  Descriptions,
  Button,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { DownloadOutlined, InboxOutlined } from '@ant-design/icons';
import UIHelper from 'helpers/UIHelper';
import FormHelper from 'helpers/FormHelper';

const FileSection = ({ form, handleCreate, handleUploadExcelFile, handleDownloadExcel, id }) => {
  const { t } = useTranslation();
  const [fileList, setFileList] = useState([]);
  const [pdfList, setPdfList] = useState([]);

  const beforeUpload = async (file, fieldName) => {
    let allowedTypes = {};


    if (fieldName === 'file') {
      allowedTypes = {
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': true,
        'application/vnd.ms-excel': true,
      };
    } else if (fieldName === 'pdf') {
      allowedTypes = {
        'application/pdf': true,
      };
    }

    if (allowedTypes[file.type]) {
      
      if (fieldName === 'file') {
        setFileList([file]);
        handleUploadExcelFile(file);

      } else if (fieldName === 'pdf') {
        setPdfList([file]);
        const values = form.getFieldsValue();
        const filteredValues = Object.keys(values).reduce((acc, key) => {
          if (key !== 'file') { 
            acc[key] = values[key];
          }
          return acc;
        }, {});

        handleCreate({ ...filteredValues, document: [file] }, 'stepOne');
      }
      return false;
    }

    if (fieldName === 'file') {
      setFileList([]);
    } else if (fieldName === 'pdf') {
      setPdfList([]);
    }
    form.setFieldsValue({ [fieldName]: [] });
    UIHelper.openNotificationWithIcon(
      'error',
      `Invalid type of file, please select a valid ${fieldName}`
    );
    return false;
  };

  return (
    <>
      <Row gutter={24}>
        <Col span={6}>
          <Typography.Title level={3}>
            {t('Allegato', 'Attachment')}
          </Typography.Title>
        </Col>
        <Col span={9}>
          <Form.Item
            name='document'
            getValueFromEvent={FormHelper.normFile}
            rules={[
              {
                required: true,
                message: t(
                  'Please upload a PDF file',
                  'Please upload a PDF file.'
                ),
              },
            ]}
          >
            <Upload.Dragger
              name='document'
              multiple={false}
              beforeUpload={(file) => beforeUpload(file, 'pdf')}
              fileList={pdfList}
              onRemove={() => {
                setPdfList([]);
                form.setFieldsValue({ pdf: [] });
              }}
              accept='.pdf'
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text' style={{ padding: '5px' }}>
                {t('Caricare PDF con dichiarazione volume di fatturato semestrale/annuale con firma per certificazione dati')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
            <Descriptions.Item
              label={t('Formati accettati', 'Accepted formats') + ':'}
            >
              PDF
            </Descriptions.Item>
            <Descriptions.Item
              label={t('Dimensione massima', 'Maximum size') + ':'}
            >
              20MB
            </Descriptions.Item>
          </Descriptions>
          <Form.Item
            name='file'
            getValueFromEvent={FormHelper.normFile}
            rules={[
              {
                required: true,
                message: t('Please upload a file', 'Please upload a file.'),
              },
            ]}
            style={{ marginTop: '24px' }}
          >
            <Upload.Dragger
              name='file'
              multiple={false}
              beforeUpload={(file) => beforeUpload(file, 'file')}
              fileList={fileList}
              onRemove={() => {
                setFileList([]);
                form.setFieldsValue({ file: [] });
              }}
              accept='.xls,.xlsx'
              disabled={pdfList.length === 0 } 
              style={{
                opacity: pdfList.length === 0 ? 0.5 : 1,
                cursor: pdfList.length === 0 ? 'not-allowed' : 'pointer', 
              }} 
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload1')}
                'XLS', 'XLSX'
                {t('Click or drag file to this area to upload2')}
              </p>
            </Upload.Dragger>
          </Form.Item>

          <Descriptions column={1} bordered  
            style={{
              opacity: pdfList.length === 0 ? 0.5 : 1, 
            }}>
            <Descriptions.Item
              label={t('Formati accettati', 'Accepted formats') + ':'}
            >
              XLS, XLSX
            </Descriptions.Item>
            <Descriptions.Item
              label={t('Dimensione massima', 'Maximum size') + ':'}
            >
              20MB
            </Descriptions.Item>
          </Descriptions>

          <Col
            span={8}
            style={{
              display: 'flex',
              justifyContent: 'center',
              margin: 'auto',
              marginTop: '12px',
            }}
          >
            <Button
              htmlFor='download-file'
              type='primary-white'
              icon={<DownloadOutlined style={{ marginRight: '10px' }} />}
              onClick={() => window.open('https://dev.arcusnet.it/invoices_year.xlsx', '_blank')}

              style={{
                opacity: 1,
                cursor: 'pointer', 
              }} 
            >
                {t('Scarica File')}
            </Button>
          </Col>
        </Col>
      </Row>
    </>
  );
};

export default React.memo(FileSection);